import Info from "../../Alerts/Info";

export default function Instructions({job}) {
	return (
        <Info message={job.instructions} />
	)
}
